import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

const emergencyCategories = [
  'Fire',
  'Earthquake',
  'Flood',
  'Medical Emergency',
  'Power Outage',
  'Evacuation',
  'Lockdown',
  'Severe Weather',
];

export default Factory.extend({
  name: () => faker.helpers.arrayElement(emergencyCategories),
});
